"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    startAdminTaskUpdates: function () { return function (dispatch, getState) {
        var socketList = new WebSocket("wss://" + window.location.href.split("/")[2] + "/ws/tasks/list");
        var socketDiag = new WebSocket("wss://" + window.location.href.split("/")[2] + "/ws/tasks/diagnostics");
        socketList.onerror = function () {
            dispatch({ type: 'RECEIVE_ERROR_ADMIN_TASK_UPDATES' });
            window.location.reload(true);
        };
        socketList.onclose = function () {
            dispatch({ type: 'RECEIVE_ERROR_ADMIN_TASK_UPDATES' });
            window.location.reload(true);
        };
        socketList.onmessage = function (event) {
            var msg = JSON.parse(event.data);
            dispatch({ type: 'RECEIVE_ADMIN_TASK_UPDATES', tasks: msg.Tasks });
        };
        socketDiag.onerror = function () {
            dispatch({ type: 'RECEIVE_ERROR_TASK_DIAGNOSTIC_UPDATES' });
        };
        socketDiag.onmessage = function (event) {
            var msg = JSON.parse(event.data);
            dispatch({ type: 'RECEIVE_TASK_DIAGNOSTIC_UPDATES', diagnostic: msg });
        };
        dispatch({ type: 'START_ADMIN_TASK_UPDATES' });
    }; }
};
var unloadedState = {
    tasks: undefined
};
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'START_ADMIN_TASK_UPDATES':
            return unloadedState;
        case 'RECEIVE_ERROR_ADMIN_TASK_UPDATES':
            return unloadedState;
        case 'RECEIVE_ADMIN_TASK_UPDATES':
            return {
                tasks: action.tasks
            };
        case 'RECEIVE_TASK_DIAGNOSTIC_UPDATES':
            if (!state || !state.tasks)
                return state;
            var tasksToUpdate = state.tasks.map(function (task, index) {
                if (task.TaskId !== action.diagnostic.TaskId) {
                    task.Updating = false;
                    return task;
                }
                task.Updating = true;
                switch (action.diagnostic.ReportType) {
                    case 1:
                        task.VideoRate = action.diagnostic.Value;
                        break;
                    case 2:
                        task.AudioRate = action.diagnostic.Value;
                        break;
                    case 3:
                        task.MovementClientToController = action.diagnostic.Value;
                        break;
                    case 4:
                        task.MovementControllerToRcs = action.diagnostic.Value;
                        break;
                    case 5:
                        task.MovementRcsToClient = action.diagnostic.Value;
                        break;
                }
                return task;
            });
            return {
                tasks: tasksToUpdate
            };
        default:
            return state;
    }
};
//# sourceMappingURL=TaskStats.js.map